import CarouselAbstr, { CarouselOptions} from '../Carousel/CarouselAbstr';
import ViewportTracker from '../../lib/ViewportTracker';

import * as $ from 'jquery';
export default class Team extends CarouselAbstr {
	constructor(options: CarouselOptions) {
		super(options);
		this.currentIndex = 0;

		if (this.carouselEl) {
			this.init();
		}
	}

	init(): void {
		this.slides = this.buildAllSlides();
		this.buildControls();
		this.initAutoAdvance();
		this.adjustHeight(0);

		this.onChange = this.transitionHeight;
	}

	protected buildControls(): void {
		if (this.slides.length === 1)
			return;

		const controlsNext: Element = document.createElement('button');
		const controlsPrev: Element = document.createElement('button');

		controlsNext.className = `${this.carouselClass}__control carousel--next`;
		controlsPrev.className = `${this.carouselClass}__control carousel--prev`;

		this.controlPrev = this.carouselFrameEl.appendChild(controlsPrev) as HTMLElement;
		this.controlNext = this.carouselFrameEl.appendChild(controlsNext) as HTMLElement;

		if (this.controlNext) {
			this.controlNext.addEventListener('click', this.activateNextIndexCB);
		}
		if (this.controlPrev) {
			this.controlPrev.addEventListener('click', this.activatePrevIndexCB);
		}
		if (this.controlNext || this.controlPrev) {
			this.carouselEl.classList.add(this.carouselClass + '--hasControls');
		}

		this.hammerManager.on('swipe', (event: HammerInput) => {
			event.preventDefault();
			if (event.direction === 2) {
				this.activateNextIndex();
			} else if (event.direction === 4) {
				this.activatePrevIndex();
			}
		});
	}

	private buildAllSlides(): Element[] {
		const slideEl = this.carouselEl.getElementsByClassName(this.carouselClass + '__slide');
		let slides = [];
		for (let i = 0; i < slideEl.length; i++) {
			slides.push(slideEl[i]);
		}

		if (slides.length > 1) {
			this.carouselEl.classList.add(this.carouselClass + '--hasControls');
		}

		return slides;
	}

	private adjustHeight = (duration: number = 325) => {
		// Adjust height of slideDeck as necessary
		const newSlideHeight = this.slides[this.currentIndex].getBoundingClientRect().height;
		const oldFrameHeight = this.carouselFrameEl.getBoundingClientRect().height;
		$(this.carouselFrameEl).animate({
			'height': `${newSlideHeight}px`
		 }, duration);
	}

	private transitionHeight = () => { this.adjustHeight() };
}
